import {useEffect, useState} from "react";
import axios from "axios";
import {Helmet} from "react-helmet";
import Loading from "../Components/Loading/Loading";
import Card from "../Components/Card/Card";
import FadeIn from "react-fade-in";
import {inject, observer} from "mobx-react";

const Messages = (props) => {

    const [state, setState] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        props.Menu.set(false);
        setLoading(true);

        window.scrollTo(0, 0);

        axios.get(`messages`)
            .then((response) => {
                setState(response.data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false)
            })

    }, [props])

    if (loading) {
        return <Loading/>
    }

    return (
        <>
            <Helmet>
                <title>{"Ważne komunikaty - " + props.Settings.item.settings.seo_short}</title>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content="Ważne komunikaty"/>
                <link rel={"canonical"} href={window.location.href}/>
            </Helmet>
            <FadeIn transitionDuration={600} delay={200}>
                <div className="container pt--6">
                    <h1 className={"my--6 py--6 text--light"}>Ważne komunikaty</h1>
                    <div className="grid grid--3">
                        {
                            state.items && state.items.map((item, key) => (
                                <Card parent_slug={`aktualnosci`} {...item} key={`card-${key}`}/>
                            ))
                        }
                    </div>
                </div>
            </FadeIn>
        </>
    )
}

export default inject('Settings', 'Menu')(observer(Messages))
